module.exports = __webpack_public_path__ + "static/assets/265e83e13360ce2297148fe4c1b5df8e.svg";